var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "plan-card"
  }, [_c('div', {
    staticClass: "plan-details"
  }, [_c('header', {
    staticClass: "plan-header"
  }, [_c('h5', {
    staticClass: "plan-name"
  }, [_vm._v(_vm._s(_vm.name))]), _c('p', {
    staticClass: "content-hint plan-tagline"
  }, [_vm._v(_vm._s(_vm.tagline))])]), _c('div', {
    staticClass: "plan-pricing"
  }, [_vm.loading ? _c('div', {
    staticClass: "plan-price-loading"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "24",
      "indeterminate": "",
      "color": "primary",
      "role": "status",
      "aria-label": _vm.$t('plans_price_loading')
    }
  })], 1) : _c('p', {
    staticClass: "plan-price-line"
  }, [_c('span', {
    staticClass: "plan-price"
  }, [_vm._v(_vm._s(_vm.price))]), _vm.pricePeriod ? _c('span', {
    staticClass: "plan-price-period"
  }, [_vm._v(_vm._s(_vm.pricePeriod))]) : _vm._e()]), !_vm.loading ? _c('p', {
    staticClass: "content-hint plan-price-note"
  }, [_vm._v(_vm._s(_vm.priceNote))]) : _vm._e()])]), _c('v-btn', {
    staticClass: "plan-cta",
    attrs: {
      "height": 43,
      "color": "primary",
      "outlined": _vm.isOutlined,
      "depressed": !_vm.isOutlined,
      "disabled": _vm.ctaDisabled
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('cta');
      }
    }
  }, [_vm._v(_vm._s(_vm.ctaLabel))]), _vm.$slots['after-cta'] ? _c('div', {
    staticClass: "plan-after-cta"
  }, [_vm._t("after-cta")], 2) : _vm._e(), _c('div', {
    staticClass: "plan-included"
  }, [_c('p', {
    staticClass: "content-hint uppercase plan-section-label"
  }, [_vm._v(_vm._s(_vm.$t('plans_included')))]), _c('dl', {
    staticClass: "plan-quotas"
  }, _vm._l(_vm.quotas, function (quota) {
    return _c('div', {
      key: quota.label,
      staticClass: "plan-quota"
    }, [_c('dt', [_vm._v(_vm._s(quota.label))]), _c('dd', [_vm._v(_vm._s(quota.value))])]);
  }), 0)]), _c('div', {
    staticClass: "plan-features"
  }, [_c('p', {
    staticClass: "plan-features-title"
  }, [_vm._v(_vm._s(_vm.featuresTitle))]), _c('ul', _vm._l(_vm.features, function (feature) {
    return _c('li', {
      key: feature
    }, [_vm._v(_vm._s(feature))]);
  }), 0)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }